import React from 'react';

function MailView({ mail, onBack, onDelete, onReply, onForward }) {
    if (!mail) {
        return (
            <section className="mail-view empty">
                <div className="mail-view-empty">
                    <span className="view-empty-icon">✉️</span>
                    <h3>Выберите письмо</h3>
                    <p>Выберите письмо из списка, чтобы прочитать его</p>
                </div>
            </section>
        );
    }

    const date = new Date(mail.date);

    return (
        <section className="mail-view">
            <header className="mail-view-toolbar">
                <button className="view-back-btn" onClick={onBack}>
                    ← Назад
                </button>
                <div className="view-actions">
                    <button className="view-action-btn" onClick={onReply} title="Ответить">
                        ↩️
                    </button>
                    <button className="view-action-btn" onClick={onForward} title="Переслать">
                        ↪️
                    </button>
                    <button
                        className="view-action-btn danger"
                        onClick={() => onDelete(mail.id)}
                        title="Удалить"
                    >
                        🗑️
                    </button>
                </div>
            </header>

            <div className="mail-view-content">
                <h1 className="mail-view-subject">{mail.subject}</h1>

                <div className="mail-view-meta">
                    <div className="view-avatar">{mail.from.avatar}</div>
                    <div className="view-meta-info">
                        <div className="view-from">
                            <strong>{mail.from.name}</strong>
                            <span className="view-email">&lt;{mail.from.email}&gt;</span>
                        </div>
                        <div className="view-to">
                            Кому: {mail.to}
                        </div>
                    </div>
                    <div className="view-date">
                        {date.toLocaleDateString('ru-RU', {
                            day: '2-digit', month: 'long', year: 'numeric'
                        })}
                        <br />
                        <span className="view-time">
                            {date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}
                        </span>
                    </div>
                </div>

                {mail.labels.length > 0 && (
                    <div className="view-labels">
                        {mail.labels.map(l => (
                            <span key={l} className={`view-label label-${l}`}>
                                {l === 'work' && 'Работа'}
                                {l === 'important' && 'Важное'}
                                {l === 'personal' && 'Личное'}
                                {l === 'iot' && 'IoT'}
                            </span>
                        ))}
                    </div>
                )}

                <div className="mail-view-body">
                    {mail.body.split('\n').map((line, i) => (
                        <p key={i}>{line || '\u00A0'}</p>
                    ))}
                </div>

                {mail.attachments.length > 0 && (
                    <div className="mail-view-attachments">
                        <h4>Вложения ({mail.attachments.length})</h4>
                        <div className="attachments-list">
                            {mail.attachments.map((a, i) => (
                                <div key={i} className="attachment-item">
                                    <span className="attachment-icon">📎</span>
                                    <div className="attachment-info">
                                        <span className="attachment-name">{a.name}</span>
                                        <span className="attachment-size">{a.size}</span>
                                    </div>
                                    <button className="attachment-download">⬇</button>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="mail-view-reply">
                    <button className="reply-btn primary" onClick={onReply}>
                        ↩️ Ответить
                    </button>
                    <button className="reply-btn secondary" onClick={onForward}>
                        ↪️ Переслать
                    </button>
                </div>
            </div>
        </section>
    );
}

export default MailView;